<template>
  <div class="page-exhibition" :class="{'mobile': _isMobile}">
    <div class="exhibition-wrap " :class="{'pc': !_isMobile}">
      <cmpBanner bannerType="3"></cmpBanner>

      <div class="g-wrap">
        <div class="g-content">
          <!-- 头部图片 勿删 -->
          <!-- <div class="m-banner-top">
            <div class="top-box">
              <div class="pic-box" v-if="detailData.picture">
                <img v-lazy="detailData.picture">
              </div>

              <div class="label-box m-font-4">
                <h1 class="tc m-font-1 mb-40">{{detailData.name}}</h1>
                <p class="txt">
                  <label>展览地点: </label>
                  <span>{{detailData.position}}</span>
                </p>
                <p class="txt">
                  <label>展览类型: </label>
                  <span class="status">常设展览</span>
                </p>
              </div>
            </div>
          </div> -->

          <div class="con">
            <!-- <h1 class="g-title-2 mb-30">展览详情</h1> -->
            <cmpDetail :detailData="detailData"></cmpDetail>
            <!-- <div class="g-detail-html trans">
              <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dolorum qui, quidem numquam modi eveniet debitis id nulla expedita architecto accusamus ipsam iusto doloribus sit autem, repellendus dolor recusandae. Perspiciatis, libero?</p>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@assets/css-mobile/exhibition/detail.scss'
export default {
  data() {
    return {
      pageType: this.$route.query.pageType,
      detailData: {},
      detailId: this.$route.query.id,
    }
  },
  methods: {
    getDetailData() {
      this.listLoading = true
      this.$http
        .get('/webapi/exhibition/detail', {
          id: this.detailId
        })
        .then(res => {
          if (res.success) {
            this.detailData = res.data
          } else {
            this.$message.error(res.message)
          }
        }).catch(err => {
        })
    },
    setBread() {
      // 动态修改面包屑 2 资讯  6 制度建设
      console.log('00', this.pageType)
      switch(this.pageType) {
        case '1':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            }, 
            {
              text: '社教活动',
              href: '/activity?pageType=1'
            }, 
            {
              text: '详情',
              disabled: true
            }
          ])
          break
        case '2':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            }, 
            {
              text: '游学活动',
              href: '/activity?pageType=2'
            }, 
            {
              text: '详情',
              disabled: true
            }
          ])
          break
        case '3':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            }, 
            {
              text: '讲座',
              href: '/activity?pageType=3'
            }, 
            {
              text: '详情',
              disabled: true
            }
          ])
          break
        case '4':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            }, 
            {
              text: '手工',
              href: '/activity?pageType=4'
            }, 
            {
              text: '详情',
              disabled: true
            }
          ])
          break
        case '5':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            }, 
            {
              text: '其他',
              href: '/activity?pageType=5'
            }, 
            {
              text: '详情',
              disabled: true
            }
          ])
          break
      }
    }
  },
  created() {
    // this.setBread()
    this.getDetailData()
  }
}
</script>

<style lang="scss" scoped>
.exhibition-wrap {
  .g-detail-html {
    width: 100%;
  }
}
</style>


